/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_HoursInputs */

const en_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hours`)
};

const es_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas`)
};

const fr_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heures`)
};

const de_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stunden`)
};

const ja_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用時間`)
};

const zh_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用小时数`)
};

const ar_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساعات الاستخدام`)
};

const id_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jam`)
};

const it_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ore di Utilizzo`)
};

const ru_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часы наработки`)
};

const pt_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas`)
};

const ko_field_hours = /** @type {(inputs: Field_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용 시간`)
};

/**
* | output |
* | --- |
* | "Hours" |
*
* @param {Field_HoursInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_hours = /** @type {((inputs?: Field_HoursInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_HoursInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_hours(inputs)
	if (locale === "es") return es_field_hours(inputs)
	if (locale === "fr") return fr_field_hours(inputs)
	if (locale === "de") return de_field_hours(inputs)
	if (locale === "ja") return ja_field_hours(inputs)
	if (locale === "zh") return zh_field_hours(inputs)
	if (locale === "ar") return ar_field_hours(inputs)
	if (locale === "id") return id_field_hours(inputs)
	if (locale === "it") return it_field_hours(inputs)
	if (locale === "ru") return ru_field_hours(inputs)
	if (locale === "pt") return pt_field_hours(inputs)
	return ko_field_hours(inputs)
});